export default __webpack_public_path__ + "1df6d0dd065c664e99f19b55befad1c5.png";